export default function initAnchorScroll(options) {
  var opts = options || {};
  var headerSelector = opts.headerSelector || '#header';
  var fixedDuration = typeof opts.duration === 'number' ? opts.duration : null;
  var extraOffset = typeof opts.extraOffset === 'number' ? opts.extraOffset : 10;
  var onNavigate = typeof opts.onNavigate === 'function' ? opts.onNavigate : null;

  function getHeaderOffset() {
    var header = document.querySelector(headerSelector);
    if (!header) return 0;
    return header.offsetHeight || 0;
  }

  function isFancyboxOpen() {
    return !!document.querySelector('.fancybox__container');
  }

  function parseHashTarget(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    var raw = hash.slice(1);
    var id = raw.split('?')[0].split('&')[0];
    return id || null;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function durationForDistance(px) {
    var min = 200;
    var max = 520;
    var factor = 0.25;
    return clamp(Math.round(min + px * factor), min, max);
  }

  function animateScrollTo(y, ms) {
    var start = window.pageYOffset || document.documentElement.scrollTop || 0;
    var diff = y - start;
    var startTime = null;

    function step(ts) {
      if (!startTime) startTime = ts;
      var t = (ts - startTime) / ms;
      if (t > 1) t = 1;

      var eased = easeOutCubic(t);
      window.scrollTo(0, Math.round(start + diff * eased));

      if (t < 1) window.requestAnimationFrame(step);
    }

    window.requestAnimationFrame(step);
  }

  function scrollToHash(hash, push) {
    var id = parseHashTarget(hash);
    if (!id) return false;

    var el = document.getElementById(id);
    if (!el) return false;

    var headerH = getHeaderOffset();
    var rect = el.getBoundingClientRect();
    var top = (window.pageYOffset || document.documentElement.scrollTop || 0) + rect.top;

    var targetY = Math.max(0, top - headerH - extraOffset);

    if (push) {
      try {
        window.history.pushState(null, '', hash);
      } catch (e) {
        window.location.hash = hash;
      }
    }

    if (onNavigate) onNavigate(hash);

    var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var distance = Math.abs(targetY - currentY);

    var ms = fixedDuration !== null
      ? fixedDuration
      : durationForDistance(distance);

    animateScrollTo(targetY, ms);
    return true;
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a) return;

    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    if (a.hasAttribute('data-no-scroll')) return;

    e.preventDefault();
    scrollToHash(href, true);
  });

  if (window.location.hash) {
    window.requestAnimationFrame(function () {
      scrollToHash(window.location.hash, false);
    });
  }

  window.addEventListener('popstate', function () {
    if (isFancyboxOpen()) {
      return;
    }

    if (window.location.hash) {
      scrollToHash(window.location.hash, false);
    }
  });

  return {
    scrollToHash: function (hash) {
      return scrollToHash(hash, true);
    }
  };
}